import ENV_VARIABLE from './ENV_VARIABLE'
import GW_PATH from './GW_PATH'
import CONSOLE_TYPE from './CONSOLE_TYPE'

export const NX_LOCAL_PLATFORM = {
  JPPC: 'jppc',
  KRPC: 'krpc',
  ARENA: 'arena',
}

export {
  ENV_VARIABLE,
  GW_PATH,
  CONSOLE_TYPE,
}
